/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-07 15:05:46
 * @LastEditors: linxi
 * @LastEditTime: 2021-04-20 20:23:57
 */
import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface stordetailBody {
    id: number,
    name?: string,
    productInfo?: string,
    productDate?: string,
    deadline?: string,
    batchNo?: string,
    unitPrice?: number,
    retailPrice?: number,
    count?: number,
    totalPrice?: number,
    tenantMaterialsCatalogId?: number,
    tenantInventoryReceiptsId?: number,
}

export function storedetailPage(
    tenantInventoryReceiptsId: number,
): Request {
    return {
        url: `${API_PREFIX}/blade-store/inventoryreceiptsitem/page`,
        method: "GET",
        params: {
            tenantInventoryReceiptsId,
        }
    }
}

export function storedetailSave(
    body: stordetailBody
): Request {
    return {
        url: `${API_PREFIX}/blade-store/inventoryreceiptsitem/submit`,
        method: "POST",
        body
    }
}

export function storedetailRemove(
    id: string
): Request {
    return {
        url: `${API_PREFIX}/blade-store/inventoryreceiptsitem/remove`,
        method: "POST",
        params: {
            ids: id
        }
    }
}

export interface ExportExcelParams {
    tenantInventoryReceiptsId ?:string
  }
// 导出
export function getExportExcel( tenantInventoryReceiptsId ?:string): Request {
    return {
      url: `${API_PREFIX}/blade-store/inventoryreceiptsitem/log/exportexcel`,
      method: "POST",
      responseType: "blob",
      body:{tenantInventoryReceiptsId},
    };
  }
  